import Button from "./Button.interface";

export default interface IListAction {
    type?: IListActionType
    content?: string
    component?: string
    button?: Button
    icon?: string
    menu?: Button[],
    props?: Object
}

export enum IListActionType {
    content = 'content',
    component = 'component',
    button = 'button',
    icon = 'icon',
    menu = 'menu'
}
